var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{class:{'mobile-image-size' : _vm.isMobile},attrs:{"src":require("../assets/fartexcup.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }